import axios, { AxiosRequestConfig } from 'axios';
import { getOdataRootUrl } from '@bingads-webui-react/copilot-utils';
import { formatTodayGridDate } from './utils';

const MAXIMUM_AD_FETCH_COUNT = '100';

export interface IFetchAdUrlProps {
  customerId: string;
  accountId: string;
  campaignId: string;
  params?: {
    $expand: string;
    $top: string;
    $count: string;
    $orderby: string;
    $select: string;
  };
}

const AdOdataConfig = {
  $expand: 'AdGroup($select=Id,Name),Campaign($select=CampaignSettings,CampaignSubType,CampaignType,DisplayBiddingStrategyType,ExperimentId,Id),Labels',
  $top: MAXIMUM_AD_FETCH_COUNT,
  $count: 'true',
  $orderby: 'DeliveryStatus asc',
  $select: 'AdStrength,AdStrengthActionItems,AdsByBing,DeliveryStatus,DeliveryStatusDetails,DestinationUrl,DevicePreference,DisplayUrl,EditorialCategories,FinalUrlSuffix,FinalUrls,Id,MobileFinalUrls,Model.AppInstallAd/AltText,Model.AppInstallAd/AppPlatform,Model.AppInstallAd/AppStoreId,Model.AppInstallAd/DeviceType,Model.AppInstallAd/MediaUrl,Model.ProductAd/PromotionalText,Model.ResponsiveAd/BusinessName,Model.ResponsiveAd/CallToAction,Model.ResponsiveAd/CallToActionLanguage,Model.ResponsiveAd/Descriptions,Model.ResponsiveAd/Headline,Model.ResponsiveAd/Headlines,Model.ResponsiveAd/HotSpots,Model.ResponsiveAd/Images,Model.ResponsiveAd/ImpressionTrackingUrls,Model.ResponsiveAd/LandscapeImageMediaId,Model.ResponsiveAd/LandscapeImageMediaUrl,Model.ResponsiveAd/LandscapeLogoMediaId,Model.ResponsiveAd/LandscapeLogoMediaUrl,Model.ResponsiveAd/LongHeadline,Model.ResponsiveAd/LongHeadlines,Model.ResponsiveAd/SquareImageMediaId,Model.ResponsiveAd/SquareImageMediaUrl,Model.ResponsiveAd/SquareLogoMediaId,Model.ResponsiveAd/SquareLogoMediaUrl,Model.ResponsiveAd/VerifiedTrackingSettings,Model.ResponsiveAd/Videos,Model.ResponsiveSearchAd/Descriptions,Model.ResponsiveSearchAd/Headlines,NativePreference,Path1,Path2,PerformanceMetrics/AbsoluteTopImpressionRate,PerformanceMetrics/AverageCPC,PerformanceMetrics/CTR,PerformanceMetrics/Clicks,PerformanceMetrics/ConversionsCredit,PerformanceMetrics/Impressions,PerformanceMetrics/Spend,PerformanceMetrics/TopImpressionRate,PerformanceMetrics/ViewThroughConversionsCredit,Status,Text,TextPart2,Title,TitlePart1,TitlePart2,TitlePart3,TrackingUrlTemplate,Type,UrlCustomParameters',
};

export interface IFetchAdsDataProps extends IFetchAdUrlProps {
  ccToken: string;
}

export function getFetchAdUrl({
  customerId,
  accountId,
  campaignId,
  params = AdOdataConfig,
}: IFetchAdUrlProps) {
  const queryString = new URLSearchParams(params);

  return `${getOdataRootUrl()}/ODataApi/Campaign/V2/Customers(${customerId})/Accounts(${accountId})/Campaigns(${campaignId})/Ads/Default.GridData?${queryString}`;
}

export function fetchAdsData({
  accountId,
  customerId,
  campaignId,
  ccToken,
}: IFetchAdsDataProps) {
  const url = getFetchAdUrl({ customerId, accountId, campaignId });

  const postDataParams = {
    gridDataParameters: {
      DateRange: {
        StartDate: formatTodayGridDate(),
        EndDate: formatTodayGridDate(),
      },
      CurrentCustomerId: customerId,
    },
  };

  return axios.post(
    url,
    {
      ...postDataParams,
    },
    {
      headers: {
        Authorization: ccToken,
        'content-type': 'application/json',
      },

    } as AxiosRequestConfig,
  );
}
